import React, { FC, MouseEvent, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import { LinkingStatus } from '../LinkingStatus';
import { useStyles } from './ProviderTile.styles';
import { ProviderTileStyledComponentProps } from './provider-tile-styled-component-props';

export const ProviderDefaultTile: FC<ProviderTileStyledComponentProps> = ({
  provider,
  disabled,
  isConnected,
  onClick,
  onUnlinkClick,
}) => {
  const { classes } = useStyles({ status: provider?.connectionStatus });

  const onUnlinkHandler = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();

      onUnlinkClick();
    },
    [onUnlinkClick]
  );

  return (
    <Box className={classNames(classes.root, { [classes.disabled]: disabled })} onClick={onClick}>
      <Box className={classes.titleContainer}>
        <Box className={classes.icon}>
          <img src={provider.providerIcon} alt={provider.platformName} />
        </Box>
        <Typography className={classes.platformId}>{provider.platformName}</Typography>
      </Box>
      <Box className={classes.controls}>
        <LinkingStatus status={provider.connectionStatus} />
        {isConnected ? (
          <Typography onClick={onUnlinkHandler} className={classes.unlink}>
            Unlink
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};
